import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../../../core/services/auth/auth-guard.service';
import {
  UsuarioPerfil,
  usuarioPerfilAdministrador,
  usuarioPerfilAtendente,
  usuarioPerfilGerente,
  usuarioPerfilRepresentante,
} from '../../../../home/usuario/usuario-perfil';

/** Acessos permitidos as Notas Fiscais */
export const acessosNotaFiscal: UsuarioPerfil[] = [
  usuarioPerfilAdministrador,
  usuarioPerfilGerente,
  usuarioPerfilAtendente,
  usuarioPerfilRepresentante,
];

@Injectable()
export class CanActivateNotasFiscais implements CanActivate, CanActivateChild {
  constructor(private authGuard: AuthGuard) {}

  canActivate(): boolean {
    return this.authGuard.canActivateAcesso(acessosNotaFiscal);
  }

  canActivateChild(): boolean {
    return this.authGuard.canActivateAcesso(acessosNotaFiscal);
  }
}
